<!-- mettal-3\src\components\Drawing.vue -->
<template>
  <div :class="[`drawing`, className || ``]">
    <img
      class="vector-173"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-576.svg"
      alt="Vector"
    />
    <img
      class="vector-174"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-577.svg"
      alt="Vector"
    />
    <img
      class="vector-175"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-578.svg"
      alt="Vector"
    />
  </div>
</template>

<script>
export default {
  name: "Drawing",
  props: ["className"],
};
</script>

<style>
.drawing {
  aspect-ratio: 1;
  height: 83.34%;
  left: 0;
  position: absolute;
  top: 10%;
  width: 9.29%;
}

.vector-173 {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 25%;
}

.vector-174 {
  height: 100%;
  left: 33.34%;
  position: absolute;
  top: 0;
  width: 66.67%;
}

.vector-175 {
  height: 50%;
  left: 45.84%;
  position: absolute;
  top: 25%;
  width: 41.69%;
}

.drawing.drawing-2 .vector-174,
.drawing.drawing-3 .vector-174,
.drawing.drawing-4 .vector-174 {
  width: 66.66%;
}

.drawing.drawing-2 .vector-175,
.drawing.drawing-3 .vector-175,
.drawing.drawing-4 .vector-175 {
  width: 41.68%;
}

.drawing.drawing-3 {
  height: 83.33%;
}

.drawing.drawing-4 {
  height: 83.33%;
  width: 9.13%;
}
</style>
